import styles from "./BoostHistory.module.scss"
import Headphones from "../../../../../assets/images/product-image-headphones.png"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"
import InfoBadge from "../../../../../components/common/SellerCommonComponents/InfoBadge/InfoBadge"

const CurrentBoostedProducts = () => {
  const data = [
    {
      product: { image: Headphones, name: "Blue Colored Headphones" },
      category: "Electronics",
      boostStartDate: "26/07/24",
      boostEndDate: "26/07/24",
      price: "$33.99",
      sales: 30,
      ctr: "5%",
      conversionRate: "3%",
    },
    {
      product: { image: Headphones, name: "Blue Colored Headphones" },
      category: "Electronics",
      boostStartDate: "26/07/24",
      boostEndDate: "26/07/24",
      price: "$33.99",
      sales: 30,
      ctr: "5%",
      conversionRate: "3%",
    },
    {
      product: { image: Headphones, name: "Blue Colored Headphones" },
      category: "Electronics",
      boostStartDate: "26/07/24",
      boostEndDate: "26/07/24",
      price: "$33.99",
      sales: 30,
      ctr: "5%",
      conversionRate: "3%",
    },
  ]

  const columns = [
    {
      name: "Product",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <div>
            <img src={row.product.image} alt="" width={35} height={33} />
          </div>
          <div>{row.product.name}</div>
        </div>
      ),
      grow: 2,
    },
    {
      name: "Category",
      selector: (row) => row.category,
      grow: 1,
    },
    {
      name: "Boost Start Date",
      selector: (row) => row.boostStartDate,
      grow: 1,
    },
    {
      name: "Boost End Date",
      selector: (row) => row.boostEndDate,
      grow: 1,
    },
    {
      name: "Price",
      selector: (row) => row.price,
      grow: 1,
    },
    {
      name: "Sales",
      selector: (row) => row.sales,
      grow: 1,
    },
    {
      name: "CTR",
      selector: (row) => row.ctr,
      grow: 1,
    },
    {
      name: "Conversion Rate",
      selector: (row) => row.conversionRate,
      grow: 1,
    },
  ]

  return (
    <div className="bg-white p-3 d-flex flex-column gap-3">
      <div className="d-flex">
        <InfoBadge>Selected Products: 9</InfoBadge>
      </div>

      <DatatableComponent columns={columns} data={data} selectableRows type={"gray-bordered"} responsive />
    </div>
  )
}

export default CurrentBoostedProducts
